module.exports = __webpack_public_path__ + "static/img/debris.efbdf663.png";